import { VerifyContractTokenInput } from '../../gql/graphql';

import authService from '../../services/auth.service';
import { TokenErrors } from './verifyOobaToken';

const verifyContractToken = async (input: VerifyContractTokenInput): Promise<[boolean, TokenErrors | null]> => {
  try {
    const { data, errors } = await authService.verifyContractToken(input);

    if (errors) {
      console.error(errors);
      return [false, TokenErrors.Invalid];
    }

    if (data?.verifyContractToken?.verifyContractTokenErrors?.length) {
      console.error(data.verifyContractToken.verifyContractTokenErrors);
      if (data.verifyContractToken.verifyContractTokenErrors.some((e) => e.__typename === 'ExpiredToken')) {
        return [false, TokenErrors.Expired];
      }

      return [false, TokenErrors.Invalid];
    }

    return [true, null];
  } catch (e) {
    console.error(e);
    return [false, TokenErrors.Invalid];
  }
};

export default verifyContractToken;
